import { Box, Select } from '@chakra-ui/react'
import type { FieldError, FieldValues } from 'BrokerTsLib/src/rhf'

import { InputGroup } from '../../../components/InputGroup'

export const PhoneInputGroup = ({ select, input, errors }: { select?: FieldValues; input: FieldValues; errors?: FieldError | undefined; }) => {

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: select ? 'auto 1fr' : 'auto',
        placeContent: select ? 'start' : 'normal',
        placeItems: 'start',
        gap: 2,
        width: '100%',
      }}
    >
      {select && <Select {...select}>
        {['+420', '+421']
          .map((prefix) => {
            return (
              <option key={prefix} value={prefix}>
                {prefix}
              </option>
            )
          })}
      </Select>}

      <InputGroup
        inputMode="tel"
        pattern={select ? '[0-9\\s]+' : '[\\+0-9\\s]+'}
        errors={errors}
        w={'full'}
        {...input} />
    </Box>
  )
}